import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { deletePromotionsStart, getAllCmsStart, getAllPromotionsStart, updateSACMSStatusStart } from '../../../../store/redux-slices/fetchData'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

const usePromotionListing = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const isInitialRender = useDidMountEffect()
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: ""
  })
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [status, setStatus] = useState('')
  const [active, setActive] = useState('')
  const [statusShow, setStatusShow] = useState(false)
  const [cmsId, setCmsId] = useState('')
  const [tenantId, setTenantId] = useState('')
  const [name, setName] = useState()

  const { promotionsData, loading } = useSelector((state) => state.fetch)
  const totalPages = promotionsData?.data?.pagination?.totalPages || 1
  const totalCount = promotionsData?.data?.pagination?.total || 0
  const fetchCMS = () => {
    dispatch(
      getAllPromotionsStart({
        limit,
        pageNo: page,
        tenantId: selectedPortal,
        adminId: selectedClient,
        search,
        isActive: active
      })
    )
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          fetchCMS()
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    !isInitialRender && fetchCMS()
  }, [page])

  useEffect(() => {
    setPage(1)
    fetchCMS()
  }, [limit, selectedPortal, selectedClient, active])

  const handleStatusShow = (id, status, tenantId, myName) => {
    setCmsId(id)
    setStatus(!status)
    setStatusShow(true)
    setTenantId(tenantId)
    setName(myName)
  }

  const handleYes = () => {
    dispatch(
      updateSACMSStatusStart({
        data: {
          code: 'CMS',
          cmsPageId: cmsId,
          status,
          tenantId
        },
        limit,
        page,
        selectedPortal,
        selectedClient,
        search,
        active
      })
    )
    setStatusShow(false)
  }

  const handleDeletePromotions = (promotionId, slug) => {
    dispatch(deletePromotionsStart({
      promotionId, slug,
      limit,
      pageNo: page,
      tenantId: selectedPortal,
      adminId: selectedClient,
      search,
      isActive: active
    }))
  }

  return {
    navigate,
    limit,
    page,
    search,
    selectedClient,
    setPage,
    setLimit,
    setSearch,
    setSelectedClient,
    promotionsData: promotionsData?.data?.result,
    totalPages,
    selectedPortal,
    setSelectedPortal,
    loading,
    handleStatusShow,
    statusShow,
    setStatusShow,
    handleYes,
    status,
    active,
    setActive,
    name,
    handleDeletePromotions,
    imageModal, setImageModal,
    totalCount
  }
}

export default usePromotionListing
